import { request } from '../request'
import { Account, BillingAccountWithBillingInfo, AccountMeta } from '../types'

export class AccountService {

  getAccount(): Promise<Account> {
    return request.get(`/api/account.json`)
  }

  updateAccount(body: object): Promise<any> {
    return request.put(`/api/account.json`, { account: body })
  }

  getBillingAccount(): Promise<BillingAccountWithBillingInfo> {
    return request.get(`/api/account/billing_account.json`)
  }

  updateBillingAccount(body: object): Promise<any> {
    return request.put(`/api/account/billing_account.json`, body)
  }

  createBillingAccount(body: object): Promise<any> {
    return request.post(`/api/account/billing_account.json`, body)
  }

  // Activates all customers subscriptions with plans - called exclusively on signup
  activate(): Promise<any> {
    return request.post(`/api/account/activate.json`)
  }

  getMetadata(): Promise<AccountMeta> {
    return request.get('/api/account/metadata.json')
  }

}
